 const ERROR_ADMIN_NOTICE_SELECTOR = '.jw-error-notice';
                
  document.addEventListener('DOMContentLoaded', () => {
    const dismissibleNotice = document.querySelector(ERROR_ADMIN_NOTICE_SELECTOR);
    
    if (!dismissibleNotice) {
        return;
    }
    
    const {
        ajaxUrl,
        action,
        nonce
    } = window.justwatchPartnerIntegrationsErrorConfig;
    const query = new URLSearchParams({
        action,
        nonce,
    });
    dismissibleNotice.addEventListener('click', function() {
        // Delete the transient when the notice is dismissed
        fetch(ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: query,
        });
    });
});